module.exports = __WEBPACK_EXTERNAL_MODULE_22__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/Subject"
// module id = 22
// module chunks = 0